import { render, staticRenderFns } from "./CourseCreate.vue?vue&type=template&id=c2b1f47e&"
import script from "./CourseCreate.vue?vue&type=script&lang=js&"
export * from "./CourseCreate.vue?vue&type=script&lang=js&"
import style0 from "./CourseCreate.vue?vue&type=style&index=0&id=c2b1f47e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports